import { cr } from "fire-wind-water";
import Radio from "ant-design-vue/lib/radio"; // 加载 JS
import "ant-design-vue/lib/radio/style/css"; // 加载 CSS
import Vue from "vue";
import common from "./common";
Vue.use(Radio);
const radioMixin = {
  props: {
    field: {},
    fieldValue: "",
    fieldResult: {},
    checkFlag: false,
    fieldStyle: {
      type: String,
      default: "style1",
    },
  },
  data() {
    return {
      fieldObj: {},
      optionId: [], //当前选中的option
    };
  },
  watch: {
    checkFlag() {
      //校验
      this.fieldObj.dirty = true;
      // 当 fieldExtraType == 10 且 required == 1 时，必须勾选才能提交
      if (this.field.fieldExtraType == "10" && this.field.required == 1) {
        if (!this.fieldObj.isSelected) {
          this.fieldObj.invalid = true;
          this.fieldObj.validationMessage =
            this.field.errorRequired || "请勾选此项";
        } else {
          this.fieldObj.invalid = false;
        }
      }
      //输出结果到父级
      common.updateData(this, this.fieldObj);
    },
  },
  created() {
    if (this.field.fieldExtraType == "10") {
      this.fieldObj = new window.$sk.CustomPolicy(this.field);
      this.fieldObj.initValue(this.fieldObj.isSelected);
      return;
    }
    if (this.field.fieldLevel == 4) {
      this.field.errorRequired = (
        (window.$sk && window.$sk.$t) ||
        function () {
          return "请选择";
        }
      )("field.please_select");
    }
    this.fieldObj = new window.$sk.Radio(this.field);
    this._translateOptions();
    // DICT 字段异步加载后重新翻译
    if (this.field.listOptionType == "DICT") {
      this.$watch(
        () => this.fieldObj.listOptions && this.fieldObj.listOptions.length,
        () => this._translateOptions()
      );
    }
    cr.each(this.fieldObj.listOptions, (m) => {
      if (m.isDefault == 1) {
        this.optionId = m.optionId;
        this.fieldObj.setValue(m.optionId);
      }
    });
    //回填数据
    if (!this.fieldValue) {
      return;
    }
    cr.each(this.fieldObj.listOptions, (b) => {
      if (b.optionValue == this.fieldValue) {
        this.optionId = b.optionId;
        this.fieldObj.setValue(b.optionId);
      }
    });
  },
  methods: {
    inputBlur(e, o) {
      this.fieldObj.setOtherValue(o.optionId, e.target.value);
    },
    onChange(e) {
      this.optionId = e.target.value;
      this.fieldObj.setValue(e.target.value);
      let value = "";
      //针对客户管理里面的独立选项 fieldLevel 1是全局 2是模块 4 自定义的
      if (
        (this.field.fieldLevel == 1 ||
          this.field.fieldLevel == 2 ||
          this.field.fieldLevel == 3) &&
        this.field.listOptionType == "CUSTOM"
      ) {
        this.fieldObj.listOptions.filter((b) => {
          if (b.checked) {
            value = b.optionValue;
          }
        });
      }
      this.$emit("change", {
        displayType: this.fieldObj.displayType,
        value: value ? value : e.target.value,
        rulesInfo: this.field.rulesInfo,
        rulesCode: this.field.fieldName,
        sortBy: this.field.sortBy,
      });
    },
    handleChange(e) {
      this.fieldObj.setValue(e.target.checked);
      // 当 fieldExtraType == 10 且 required == 1 时，更新验证状态
      if (this.field.fieldExtraType == "10" && this.field.required == 1) {
        if (this.fieldObj.dirty) {
          if (!e.target.checked) {
            this.fieldObj.invalid = true;
            this.fieldObj.validationMessage =
              this.field.errorRequired || "请勾选此项";
          } else {
            this.fieldObj.invalid = false;
          }
        }
      }
    },
    startsWithDiv() {
      const html = this.fieldObj.privacyPolicyTitle;
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");
      const rootElement = doc.body.firstChild;
      const eleName = rootElement?.tagName?.toLowerCase() || "";
      return rootElement && ["div", "p"].includes(eleName) && eleName;
    },
    policyClass() {
      const name = this.startsWithDiv();
      return name ? `policy-${name}` : "policy-inline";
    },
    _translateOptions() {
      var lang = (window.$sk && window.$sk.$lang) || "zh_CN";
      var langKey = lang.toLowerCase();
      if (lang === "zh_CN") return;
      var opts = this.fieldObj && this.fieldObj.listOptions;
      if (!opts) return;
      var fieldOpts = (this.field && this.field.listOptions) || [];
      var dictInfo = (this.field && this.field.dictInfo) || [];
      var changed = false;
      var self = this;
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        var translated = null;
        if (o.i18n && (o.i18n[lang] || o.i18n[langKey])) {
          translated = o.i18n[lang] || o.i18n[langKey];
        } else if (o[lang] || o[langKey]) {
          translated = o[lang] || o[langKey];
        } else {
          var src = fieldOpts.filter(function (f) {
            return f.optionId == o.optionId || f.optionValue == o.optionValue;
          })[0];
          if (src && src.i18n && (src.i18n[lang] || src.i18n[langKey])) {
            translated = src.i18n[lang] || src.i18n[langKey];
          }
        }
        if (!translated && dictInfo.length > 0) {
          var dSrc = dictInfo.filter(function (d) {
            return d.paramId == o.optionId || d.name == o.optionValue;
          })[0];
          if (dSrc && dSrc.i18n && (dSrc.i18n[langKey] || dSrc.i18n[lang])) {
            translated = dSrc.i18n[langKey] || dSrc.i18n[lang];
          }
        }
        if (translated) {
          self.$set(o, "optionLabel", translated);
          changed = true;
        }
      }
      if (changed) {
        this.fieldObj._i18nVersion = (this.fieldObj._i18nVersion || 0) + 1;
      }
    },
  },
};
export default radioMixin;
